import React from 'react'
import Wordle from './components/Wordle'
import DefaultLayout from './components/layouts/Default'
import { ErrorBoundary } from 'react-error-boundary'

function ErrorFallback({ error }: { error: Error }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre className="text-red-600">{error.message}</pre>
    </div>
  )
}

function App() {
  const queryParams = new URLSearchParams(window.location.search)
  const word = queryParams.get('word')

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <DefaultLayout>
        <Wordle queryWord={word} />
      </DefaultLayout>
    </ErrorBoundary>
  )
}

export default App
